import store from '@state/store'
import { authGuard } from './auth/auth-guard'

export default [
  {
    path: '/',
    name: 'home',
    component: () => lazyLoadView(import('@views/home.vue')),
  },
  {
    name: 'user-management',
    path: '/user-management',
    meta: {
      admin: true,
    },
    component: () => lazyLoadView(import('@views/user/user-management.vue')),
    beforeEnter: authGuard,
  },
  {
    name: 'user-profile',
    path: '/user-profile/:userId',
    meta: {
      admin: true,
    },
    component: () => lazyLoadView(import('@views/user/user-profile.vue')),
    beforeEnter: authGuard,
  },
  {
    name: 'group-profile',
    path: '/group-profile/:groupId',
    meta: {
      admin: true,
    },
    component: () => lazyLoadView(import('@views/group/group-profile.vue')),
    beforeEnter: authGuard,
  },
  {
    name: 'create-group',
    path: '/create-group',
    meta: {
      admin: true,
    },
    component: () => lazyLoadView(import('@views/group/create-group.vue')),
    beforeEnter: authGuard,
  },
  {
    name: 'create-user',
    path: '/create-user',
    meta: {
      admin: true,
    },
    component: () => lazyLoadView(import('@views/user/create-user.vue')),
    beforeEnter: authGuard,
  },
  {
    name: 'create-organization',
    path: '/create-organization',
    meta: {
      super_admin: true,
    },
    component: () =>
      lazyLoadView(import('@views/organization/create-organization.vue')),
    beforeEnter: authGuard,
  },
  {
    name: 'organization-profile',
    path: '/organization-profile/:orgId',
    meta: {
      admin: true,
    },
    component: () =>
      lazyLoadView(import('@views/organization/organization-profile.vue')),
    beforeEnter: authGuard,
  },
  {
    name: 'sim-profile',
    path: '/sim-profile/:simId',
    component: () => lazyLoadView(import('@views/sim/sim-profile.vue')),
    beforeEnter: authGuard,
  },
  {
    path: '/sim-management',
    name: 'sim-management',
    component: () => lazyLoadView(import('@views/sim/sim-management.vue')),
    beforeEnter: authGuard,
  },
  {
    name: 'create-sim',
    path: '/create-sim',
    meta: {
      admin: true,
    },
    component: () => lazyLoadView(import('@views/sim/create-sim.vue')),
    beforeEnter: authGuard,
  },
  {
    name: 'create-hardware',
    path: '/create-hardware',
    meta: {
      admin: true,
    },
    component: () => lazyLoadView(import('@views/sim/create-hardware.vue')),
    beforeEnter: authGuard,
  },
  {
    name: 'create-connection',
    path: '/create-connection',
    meta: {
      admin: true,
    },
    component: () => lazyLoadView(import('@views/sim/create-connection.vue')),
    beforeEnter: authGuard,
  },
  {
    name: 'connection-profile',
    path: '/connection-profile/:connectionId',
    meta: {
      admin: true,
    },
    component: () => lazyLoadView(import('@views/sim/connection-profile.vue')),
    beforeEnter: authGuard,
  },
  {
    name: 'hardware-profile',
    path: '/hardware-profile/:hardwareId',
    meta: {
      admin: true,
    },
    component: () => lazyLoadView(import('@views/sim/hardware-profile.vue')),
    beforeEnter: authGuard,
  },
  {
    name: 'hardware-summary',
    path: '/hardware-summary/:hardwareId',
    meta: {
      admin: true,
    },
    component: () => lazyLoadView(import('@views/sim/hardware-summary.vue')),
    beforeEnter: authGuard,
  },
  {
    path: '/container-management',
    name: 'container-management',
    component: () =>
      lazyLoadView(import('@views/container/container-management.vue')),
    beforeEnter: authGuard,
  },
  {
    name: 'container-profile',
    path: '/container-profile/:containerId',
    component: () =>
      lazyLoadView(import('@views/container/container-profile.vue')),
    beforeEnter: authGuard,
  },
  {
    name: 'create-container',
    path: '/create-container',
    meta: {
      admin: true,
    },
    component: () =>
      lazyLoadView(import('@views/container/create-container.vue')),
    beforeEnter: authGuard,
  },
  {
    path: '/figments',
    name: 'figments',
    component: () => lazyLoadView(import('@views/figment/figments.vue')),
    beforeEnter: authGuard,
  },
  {
    path: '/create-figment',
    name: 'create-figment',
    component: () => lazyLoadView(import('@views/figment/create-figment.vue')),
    beforeEnter: authGuard,
  },
  {
    path: '/figment-profile/:figmentId',
    name: 'figment-profile',
    component: () => lazyLoadView(import('@views/figment/figment-profile.vue')),
    beforeEnter: authGuard,
  },
  {
    path: '/figment-research/:figmentId/hardwareId/:hardwareId',
    name: 'figment-research',
    component: () =>
      lazyLoadView(import('@views/figment/figment-research.vue')),
    beforeEnter: authGuard,
  },
  // {
  //   path: '/research-md-1',
  //   name: 'research-md-1',
  //   component: () => lazyLoadView(import('@views/research.vue')),
  //   beforeEnter: authGuard,
  // },
  // {
  //   path: '/research-ca-1',
  //   name: 'research-ca-1',
  //   component: () => lazyLoadView(import('@views/research.vue')),
  //   beforeEnter: authGuard,
  // },
  // {
  //   path: '/research-va-1',
  //   name: 'research-va-1',
  //   component: () => lazyLoadView(import('@views/research.vue')),
  //   beforeEnter: authGuard,
  // },
  {
    path: '/research-la-1',
    name: 'research-la-1',
    component: () => lazyLoadView(import('@views/research.vue')),
    beforeEnter: authGuard,
  },
  {
    path: '/support',
    name: 'support',
    component: () => lazyLoadView(import('@views/support.vue')),
    beforeEnter: authGuard,
  },
  {
    path: '/login',
    name: 'login',
    component: () => lazyLoadView(import('@views/login.vue')),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['auth/loggedIn']) {
          // Redirect to the home page instead
          next({
            name: 'home',
          })
        } else {
          // Continue to the login page
          next()
        }
      },
    },
  },
  {
    path: '/logout',
    name: 'logout',
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        store.dispatch('auth/logOut')
        const authRequiredOnPreviousRoute = routeFrom.matched.some(
          (route) => route.meta.authRequired
        )
        // Navigate back to previous page, or home as a fallback
        next(
          authRequiredOnPreviousRoute
            ? {
                name: 'home',
              }
            : {
                ...routeFrom,
              }
        )
      },
    },
  },
  {
    path: '/404',
    name: '404',
    component: require('@views/_404.vue').default,
    // Allows props to be passed to the 404 page through route
    // params, such as `resource` to define what wasn't found.
    props: true,
  },
  // Redirect any unmatched routes to the 404 page. This may
  // require some server configuration to work in production:
  // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
  {
    path: '*',
    redirect: '404',
  },
]

// Lazy-loads view components, but with better UX. A loading view
// will be used if the component takes a while to load, falling
// back to a timeout view in case the page fails to load. You can
// use this component to lazy-load a route with:
//
// component: () => lazyLoadView(import('@views/my-view'))
//
// NOTE: Components loaded with this strategy DO NOT have access
// to in-component guards, such as beforeRouteEnter,
// beforeRouteUpdate, and beforeRouteLeave. You must either use
// route-level guards instead or lazy-load the component directly:
//
// component: () => import('@views/my-view')
//
function lazyLoadView(AsyncView) {
  const AsyncHandler = () => ({
    component: AsyncView,
    // A component to use while the component is loading.
    loading: require('@views/_loading.vue').default,
    // Delay before showing the loading component.
    // Default: 200 (milliseconds).
    delay: 400,
    // A fallback component in case the timeout is exceeded
    // when loading the component.
    error: require('@views/_timeout.vue').default,
    // Time before giving up trying to load the component.
    // Default: Infinity (milliseconds).
    timeout: 10000,
  })

  return Promise.resolve({
    functional: true,
    render(h, { data, children }) {
      // Transparently pass any props or children
      // to the view component.
      return h(AsyncHandler, data, children)
    },
  })
}
